<template>

  <div :class="{'box-loading': loading}">
    <form
      v-if="fields.length"
      @submit.prevent="save()">

      <IntegrationFields
        v-model="form"
        :fields="fields"
        :errors="validateErrors"
        :disabled="loading" />

      <div
        v-if="errorMessage"
        class="alert alert-warning">
        {{ errorMessage }}
      </div>

      <button
        type="submit"
        class="btn btn-primary mt-3"
        :disabled="loading">{{ $t('Save') }}</button>
    </form>

  </div>

</template>

<script>
import IntegrationFields from '../IntegrationFields'

export default {
  name: 'FormPage',
  components: {
    IntegrationFields
  },
  props: {
    connection: {
      type: Object,
      required: true
    },
    integration: {
      type: Object,
      required: true
    }
  },
  data () {
    // o formSchema pode vir como array ou como função que devolve o array
    const schema = this.integration.settings && this.integration.settings.formSchema
    const fields = typeof schema === 'function' ? schema() : (schema || [])
    const settings = this.connection.settings || {}
    console.log({ settings })
    const form = {}

    fields.forEach((field) => {
      form[field.key] = settings[field.key] === undefined ? null : settings[field.key]
    })

    return {
      loading: false,
      validateErrors: {},
      errorMessage: null,
      fields: fields,
      form: form
    }
  },
  methods: {
    /*
    save
    grava os campos do settings.formSchema
    */
    save () {
      this.loading = true
      this.validateErrors = {}
      this.errorMessage = null

      this.$store
      .dispatch('updateConnection', {
        integration: this.connection.integration,
        id: this.connection._id,
        data: Object.assign({}, this.form)
      })
      .then(() => {
        this.$store.dispatch('setWarn', { status: 'success' })
      })
      .catch((err) => {
        const data = err.response && err.response.data
        if (data && data.name === 'ValidationError') {
          this.validateErrors = data.errors
        } else {
          this.errorMessage = (data && data.message) || this.$t('Something went wrong')
        }
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integrations/connectors/form/Page.vue